const helpers = {
  currencify(amount) {
    return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR', currencyDisplay: 'symbol' }).format(amount);
  }
}

const localStorageHelper = {
  getFromStorage(key) {
    return localStorage.getItem(key) ? JSON.parse(localStorage.getItem(key)) : null 
  },

  updateInStorage(key, value) {
    localStorage.setItem(key, value);
  }
}

const recommendedProductsApp = {
  init() {
    this.key = STORAGE_KEYS.recommendedProducts;
    this.products = localStorageHelper.getFromStorage(this.key) ?? [];
  },

  getProduct() {
    return this.products[this.products.length - 1];
  },

  getProducts() {
    return this.products;
  },

  add(product) {
    this.products.push(product);
    this.render();
  },
  
  render() {
    if (this.products.length > 10) {
      this.products.splice(0, 1);
    }
    this.renderStorage();
  },

  renderStorage() {
    localStorageHelper.updateInStorage(this.key, JSON.stringify(this.products));
  },
}

recommendedProductsApp.init();


class MainProductSection extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    debugger;
    if (this.dataset.hidden === "true"){
      window.history.go(-1);
    }
    const product = JSON.parse(this.querySelector('[type="application/product-json"]')?.textContent);
    const productOptionsWithValues = JSON.parse(this.querySelector('[type="application/product-options-json"]')?.textContent);
    product.options_with_values = productOptionsWithValues;
    if (product?.available) 
      recommendedProductsApp.add(product)  
  }
}

customElements.define('main-product-section', MainProductSection);



(function () {
  // function footerBehindCtn() {
//   var footerHeight = document.querySelector('.footer').offsetHeight;
//   document.querySelector('main').style.marginBottom = footerHeight + 'px';
// }

// document.addEventListener('DOMContentLoaded', function() {
//   footerBehindCtn();
// });

// window.addEventListener('resize', function() {
//   footerBehindCtn();
// });
/****** header ***/
let headeritems = document.querySelector(".header__inline-menu").querySelectorAll("details");
let dropdownItems = document.querySelector(".header__submenu");
headeritems.forEach(item => {
  item.addEventListener("mouseenter", () => {
    item.setAttribute("open", true);
    let ulElement = item.querySelector("ul");
    if (ulElement !== null) {
      ulElement.addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    }
  });
  item.addEventListener("focus", () => {
    item.setAttribute("open", true);
  });
  item.addEventListener("blur", () => {
    item.removeAttribute("open");
  });
  item.addEventListener("mouseenter", () => {
      item.setAttribute("open", "");
    });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
});
if (dropdownItems !== null) {
  dropdownItems.addEventListener("mouseleave", () => {
    headeritems.forEach(item => {
      item.removeAttribute("open");
    });
  });
}
// Show the first tab and hide the rest
document.addEventListener("DOMContentLoaded", function () {
  var collectionTabs = document.querySelector(".collection_tabs");
  if (collectionTabs) {
    var firstTab = document.querySelector("#tabs-nav li:first-child");
    if (firstTab) {
      firstTab.classList.add("active");
    }

    var tabContents = document.querySelectorAll(".tab-content");
    tabContents.forEach(function (tabContent) {
      tabContent.style.display = "none";
    });
    tabContents[0].style.display = "block";

    // Click function
    var tabListItems = document.querySelectorAll("#tabs-nav li");
    tabListItems.forEach(function (tabListItem) {
      tabListItem.addEventListener("click", function () {
        tabListItems.forEach(function (item) {
          item.classList.remove("active");
        });
        this.classList.add("active");

        tabContents.forEach(function (tabContent) {
          tabContent.style.display = "none";
        });

        var activeTab = this.querySelector("a").getAttribute("href");
        document.querySelector(activeTab).style.display = "block";

        return false;
      });
    });

    var tabLinks = document.querySelectorAll("#tabs-nav a");

    tabLinks.forEach(function (tabLink) {
      tabLink.addEventListener("click", function (event) {
        event.preventDefault();

        var parent = this.parentNode;
        if (parent) {
          var positionLeft = parent.offsetLeft;
          var width = parent.offsetWidth;

          var slider = document.querySelector(".tabs .slider");
          slider.style.left = positionLeft + "px";
          slider.style.width = width + "px";
        }
      });
    });

    var actWidth = document.querySelector(".tabs #tabs-nav .active").parentNode
      .offsetWidth;
    var actPosition = document.querySelector(
      ".tabs #tabs-nav .active"
    ).offsetLeft;
    var slider = document.querySelector(".tabs .slider");
    slider.style.left = actPosition + "px";
    slider.style.width = actWidth + "px";
  }
});


var TestimonialSliser = document.querySelector(".testimonialswrap");
if (TestimonialSliser) {
var items = document.querySelectorAll(".carousel .item");
var dots = document.querySelectorAll(".carousel-indicators li");
var currentItem = 0;
var isEnabled = true;

function changeCurrentItem(n) {
  currentItem = (n + items.length) % items.length;
}

function nextItem(n) {
  hideItem("to-left");
  changeCurrentItem(n + 1);
  showItem("from-right");
}

function previousItem(n) {
  hideItem("to-right");
  changeCurrentItem(n - 1);
  showItem("from-left");
}

function goToItem(n) {
  if (n < currentItem) {
    hideItem("to-right");
    currentItem = n;
    showItem("from-left");
  } else {
    hideItem("to-left");
    currentItem = n;
    showItem("from-right");
  }
}

function hideItem(direction) {
  isEnabled = false;
  items[currentItem].classList.add(direction);
  dots[currentItem].classList.remove("active");
  items[currentItem].addEventListener("animationend", function () {
    this.classList.remove("active", direction);
  });
}

function showItem(direction) {
  items[currentItem].classList.add("next", direction);
  dots[currentItem].classList.add("active");
  items[currentItem].addEventListener("animationend", function () {
    this.classList.remove("next", direction);
    this.classList.add("active");
    isEnabled = true;
  });
}

document
  .querySelector(".carousel-control.left")
  .addEventListener("click", function () {
    if (isEnabled) {
      previousItem(currentItem);
    }
  });

document
  .querySelector(".carousel-control.right")
  .addEventListener("click", function () {
    if (isEnabled) {
      nextItem(currentItem);
    }
  });

document
  .querySelector(".carousel-indicators")
  .addEventListener("click", function (e) {
    var target = [].slice.call(e.target.parentNode.children).indexOf(e.target);
    if (target !== currentItem && target < dots.length) {
      goToItem(target);
    }
  });
}
/**** faq *****/
var FaqAccordions = document.querySelector(".faq_sec");
if (FaqAccordions) {  
(function () {
  var headers = document.querySelectorAll(".accordion_head");
  if (!headers?.length) return;
  for (var i = 0; i < headers.length; i++) {
    headers[i].addEventListener("click", openCurrAccordion);
  }
  function openCurrAccordion(e) {
    for (var i = 0; i < headers.length; i++) {
      var parent = headers[i].parentElement;
      var article = headers[i].nextElementSibling;

      if (this === headers[i] && !parent.classList.contains("open")) {
        parent.classList.add("open");
        article.style.maxHeight = article.scrollHeight + "px";
      } else {
        parent.classList.remove("open");
        article.style.maxHeight = "0px";
      }
    }
  }
  function openAccordion(e) {
    var parent = this.parentElement;
    var article = this.nextElementSibling;

    if (!parent.classList.contains("open")) {
      parent.classList.add("open");
      article.style.maxHeight = article.scrollHeight + "px";
    } else {
      parent.classList.remove("open");
      article.style.maxHeight = "0px";
    }
  }
})();
}


/**** footer accordion ***/
var windowWidth = window.innerWidth;
if (windowWidth < 750) {
   (function () {
    var FooterHeaders = document.querySelectorAll(".footermenuhead");
    if (!FooterHeaders?.length) return;
    for (var i = 0; i < FooterHeaders.length; i++) {
      FooterHeaders[i].addEventListener("click", openCurrAccordion);
    }
    function openCurrAccordion(e) {
      for (var i = 0; i < FooterHeaders.length; i++) {
        var parent = FooterHeaders[i].parentElement;
        var article = FooterHeaders[i].nextElementSibling;
  
        if (this === FooterHeaders[i] && !parent.classList.contains("open")) {
          parent.classList.add("open");
          article.style.maxHeight = article.scrollHeight + "px";
        } else {
          parent.classList.remove("open");
          article.style.maxHeight = "0px";
        }
      }
    }
  })(); 
}

/*
document.addEventListener('DOMContentLoaded', function() {
  var accordionHeaders = document.querySelectorAll('.accordion-header');

  accordionHeaders.forEach(function(header) {
    header.addEventListener('click', function() {
      var content = this.nextElementSibling;
      var icon = this.querySelector('.toggle-icon');

      // Close all other accordions
      var allContents = document.querySelectorAll('.accordion-content');
      allContents.forEach(function(otherContent) {
        if (otherContent !== content && otherContent.style.maxHeight) {
          otherContent.style.maxHeight = null;
          otherContent.previousElementSibling.querySelector('.toggle-icon').textContent = '+';
        }
      });

      // Toggle the clicked accordion
      if (content.style.maxHeight) {
        content.style.maxHeight = null;
        icon.textContent = '+';
      } else {
        content.style.maxHeight = content.scrollHeight + 'px';
        icon.textContent = '-';
      }
    });
  });
}); */

(function () {
    const eye = document.querySelector('[data-feather="eye"]');
    const eyeoff = document.querySelector('[data-feather="eye-off"]');
    const passwordField = document.querySelector("input[type=password]");
  
    if (!eye || !eyeoff || !passwordField) return;
  
  eye.addEventListener("click", () => {
    eye.style.display = "none";
    eyeoff.style.display = "block";
  
    passwordField.type = "text";
  });
  
  eyeoff.addEventListener("click", () => {
    eyeoff.style.display = "none";
    eye.style.display = "block";
  
    passwordField.type = "password";
  });
  })()
  
})();


const featuredProductFetchApp = {
  init() {
    this.product = recommendedProductsApp.getProduct();
    this.featuredProductDiv = document.querySelector('.featured-product');
  
    if (!(this.product && this.featuredProductDiv)) return;
    this.render();
  },

  render() {
    const { product } = this;
    const html = `<div class="grid__item product__media-wrapper">
        <media-gallery id="MediaGallery-template--20993645576516__81813185-3340-401f-bade-279d711e3872" role="region" aria-label="Gallery Viewer" data-desktop-layout="stacked">
          <div id="GalleryViewer-template--20993645576516__81813185-3340-401f-bade-279d711e3872" class="product__media-list"><div class="product__media-item" data-media-id="template--20993645576516__81813185-3340-401f-bade-279d711e3872-46793146925380">
                  

<div class="product-media-container media-type-image media-fit-contain global-media-settings gradient constrain-height" style="--ratio: 1.0; --preview-ratio: 1.0;">
  <noscript><div class="product__media media">
        <img src="${product.featured_image}&amp;width=1946" alt="" width="1946" height="1946" loading="lazy" sizes="(min-width: 1400px) 715px, (min-width: 990px) calc(55.0vw - 10rem), (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw / 1 - 4rem)">
      </div></noscript>

  <modal-opener class="product__modal-opener product__modal-opener--image no-js-hidden" data-modal="#ProductModal-template--20993645576516__81813185-3340-401f-bade-279d711e3872">
    <span class="product__media-icon motion-reduce quick-add-hidden product__media-icon--lightbox" aria-hidden="true"><svg aria-hidden="true" focusable="false" class="icon icon-plus" width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M4.66724 7.93978C4.66655 7.66364 4.88984 7.43922 5.16598 7.43853L10.6996 7.42464C10.9758 7.42395 11.2002 7.64724 11.2009 7.92339C11.2016 8.19953 10.9783 8.42395 10.7021 8.42464L5.16849 8.43852C4.89235 8.43922 4.66793 8.21592 4.66724 7.93978Z" fill="currentColor"></path>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M7.92576 4.66463C8.2019 4.66394 8.42632 4.88723 8.42702 5.16337L8.4409 10.697C8.44159 10.9732 8.2183 11.1976 7.94215 11.1983C7.66601 11.199 7.44159 10.9757 7.4409 10.6995L7.42702 5.16588C7.42633 4.88974 7.64962 4.66532 7.92576 4.66463Z" fill="currentColor"></path>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12.8324 3.03011C10.1255 0.323296 5.73693 0.323296 3.03011 3.03011C0.323296 5.73693 0.323296 10.1256 3.03011 12.8324C5.73693 15.5392 10.1255 15.5392 12.8324 12.8324C15.5392 10.1256 15.5392 5.73693 12.8324 3.03011ZM2.32301 2.32301C5.42035 -0.774336 10.4421 -0.774336 13.5395 2.32301C16.6101 5.39361 16.6366 10.3556 13.619 13.4588L18.2473 18.0871C18.4426 18.2824 18.4426 18.599 18.2473 18.7943C18.0521 18.9895 17.7355 18.9895 17.5402 18.7943L12.8778 14.1318C9.76383 16.6223 5.20839 16.4249 2.32301 13.5395C-0.774335 10.4421 -0.774335 5.42035 2.32301 2.32301Z" fill="currentColor"></path>
</svg>
</span>

<link href="//elcielicious.com/cdn/shop/t/5/assets/component-loading-spinner.css?v=116724955567955766481708866502" rel="stylesheet" type="text/css" media="all">

<div class="loading__spinner hidden">
  <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
    <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
  </svg>
</div>
<div class="product__media media media--transparent">
      <img src="${product.featured_image}&amp;width=1946" alt="" width="1946" height="1946" loading="lazy" class="image-magnify-lightbox" sizes="(min-width: 1400px) 715px, (min-width: 990px) calc(55.0vw - 10rem), (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw / 1 - 4rem)">
    </div>
    <button class="product__media-toggle quick-add-hidden product__media-zoom-lightbox" type="button" aria-haspopup="dialog" data-media-id="46793146925380">
      <span class="visually-hidden">
        Open media featured in modal
      </span>
    </button>
  </modal-opener></div>

                </div><div class="product__media-item" data-media-id="template--20993645576516__81813185-3340-401f-bade-279d711e3872-46793147089220">
                    

<div class="product-media-container media-type-image media-fit-contain global-media-settings gradient constrain-height" style="--ratio: 1.0; --preview-ratio: 1.0;">
  <noscript><div class="product__media media">
        <img src="//elcielicious.com/cdn/shop/files/FunkyFatChocDark6.webp?v=1702808656&amp;width=1946" alt="" srcset="//elcielicious.com/cdn/shop/files/FunkyFatChocDark6.webp?v=1702808656&amp;width=246 246w, //elcielicious.com/cdn/shop/files/FunkyFatChocDark6.webp?v=1702808656&amp;width=493 493w, //elcielicious.com/cdn/shop/files/FunkyFatChocDark6.webp?v=1702808656&amp;width=600 600w, //elcielicious.com/cdn/shop/files/FunkyFatChocDark6.webp?v=1702808656&amp;width=713 713w, //elcielicious.com/cdn/shop/files/FunkyFatChocDark6.webp?v=1702808656&amp;width=823 823w, //elcielicious.com/cdn/shop/files/FunkyFatChocDark6.webp?v=1702808656&amp;width=990 990w, //elcielicious.com/cdn/shop/files/FunkyFatChocDark6.webp?v=1702808656&amp;width=1100 1100w, //elcielicious.com/cdn/shop/files/FunkyFatChocDark6.webp?v=1702808656&amp;width=1206 1206w, //elcielicious.com/cdn/shop/files/FunkyFatChocDark6.webp?v=1702808656&amp;width=1346 1346w, //elcielicious.com/cdn/shop/files/FunkyFatChocDark6.webp?v=1702808656&amp;width=1426 1426w, //elcielicious.com/cdn/shop/files/FunkyFatChocDark6.webp?v=1702808656&amp;width=1646 1646w, //elcielicious.com/cdn/shop/files/FunkyFatChocDark6.webp?v=1702808656&amp;width=1946 1946w" width="1946" height="1946" loading="lazy" sizes="(min-width: 1400px) 715px, (min-width: 990px) calc(55.0vw - 10rem), (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw / 1 - 4rem)">
      </div></noscript>

  <modal-opener class="product__modal-opener product__modal-opener--image no-js-hidden" data-modal="#ProductModal-template--20993645576516__81813185-3340-401f-bade-279d711e3872">
    <span class="product__media-icon motion-reduce quick-add-hidden product__media-icon--lightbox" aria-hidden="true"><svg aria-hidden="true" focusable="false" class="icon icon-plus" width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M4.66724 7.93978C4.66655 7.66364 4.88984 7.43922 5.16598 7.43853L10.6996 7.42464C10.9758 7.42395 11.2002 7.64724 11.2009 7.92339C11.2016 8.19953 10.9783 8.42395 10.7021 8.42464L5.16849 8.43852C4.89235 8.43922 4.66793 8.21592 4.66724 7.93978Z" fill="currentColor"></path>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M7.92576 4.66463C8.2019 4.66394 8.42632 4.88723 8.42702 5.16337L8.4409 10.697C8.44159 10.9732 8.2183 11.1976 7.94215 11.1983C7.66601 11.199 7.44159 10.9757 7.4409 10.6995L7.42702 5.16588C7.42633 4.88974 7.64962 4.66532 7.92576 4.66463Z" fill="currentColor"></path>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12.8324 3.03011C10.1255 0.323296 5.73693 0.323296 3.03011 3.03011C0.323296 5.73693 0.323296 10.1256 3.03011 12.8324C5.73693 15.5392 10.1255 15.5392 12.8324 12.8324C15.5392 10.1256 15.5392 5.73693 12.8324 3.03011ZM2.32301 2.32301C5.42035 -0.774336 10.4421 -0.774336 13.5395 2.32301C16.6101 5.39361 16.6366 10.3556 13.619 13.4588L18.2473 18.0871C18.4426 18.2824 18.4426 18.599 18.2473 18.7943C18.0521 18.9895 17.7355 18.9895 17.5402 18.7943L12.8778 14.1318C9.76383 16.6223 5.20839 16.4249 2.32301 13.5395C-0.774335 10.4421 -0.774335 5.42035 2.32301 2.32301Z" fill="currentColor"></path>
</svg>
</span>

<link href="//elcielicious.com/cdn/shop/t/5/assets/component-loading-spinner.css?v=116724955567955766481708866502" rel="stylesheet" type="text/css" media="all">

<div class="loading__spinner hidden">
  <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
    <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
  </svg>
</div>
<div class="product__media media media--transparent">
      <img src="//elcielicious.com/cdn/shop/files/FunkyFatChocDark6.webp?v=1702808656&amp;width=1946" alt="" srcset="//elcielicious.com/cdn/shop/files/FunkyFatChocDark6.webp?v=1702808656&amp;width=246 246w, //elcielicious.com/cdn/shop/files/FunkyFatChocDark6.webp?v=1702808656&amp;width=493 493w, //elcielicious.com/cdn/shop/files/FunkyFatChocDark6.webp?v=1702808656&amp;width=600 600w, //elcielicious.com/cdn/shop/files/FunkyFatChocDark6.webp?v=1702808656&amp;width=713 713w, //elcielicious.com/cdn/shop/files/FunkyFatChocDark6.webp?v=1702808656&amp;width=823 823w, //elcielicious.com/cdn/shop/files/FunkyFatChocDark6.webp?v=1702808656&amp;width=990 990w, //elcielicious.com/cdn/shop/files/FunkyFatChocDark6.webp?v=1702808656&amp;width=1100 1100w, //elcielicious.com/cdn/shop/files/FunkyFatChocDark6.webp?v=1702808656&amp;width=1206 1206w, //elcielicious.com/cdn/shop/files/FunkyFatChocDark6.webp?v=1702808656&amp;width=1346 1346w, //elcielicious.com/cdn/shop/files/FunkyFatChocDark6.webp?v=1702808656&amp;width=1426 1426w, //elcielicious.com/cdn/shop/files/FunkyFatChocDark6.webp?v=1702808656&amp;width=1646 1646w, //elcielicious.com/cdn/shop/files/FunkyFatChocDark6.webp?v=1702808656&amp;width=1946 1946w" width="1946" height="1946" loading="lazy" class="image-magnify-lightbox" sizes="(min-width: 1400px) 715px, (min-width: 990px) calc(55.0vw - 10rem), (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw / 1 - 4rem)">
    </div>
    <button class="product__media-toggle quick-add-hidden product__media-zoom-lightbox" type="button" aria-haspopup="dialog" data-media-id="46793147089220">
      <span class="visually-hidden">
        Open media 6 in modal
      </span>
    </button>
  </modal-opener></div>

                  </div></div></media-gallery>
      </div>
      <div class="product__info-wrapper grid__item">
        <product-info id="ProductInfo-template--20993645576516__81813185-3340-401f-bade-279d711e3872" class="product__info-container" data-section="template--20993645576516__81813185-3340-401f-bade-279d711e3872" data-url="${product.url}"><h2 class="product__title h1">${product.title}
</h2><div class="no-js-hidden" id="price-template--20993645576516__81813185-3340-401f-bade-279d711e3872" role="status">
<div class="
    price price--large price--show-badge">
  <div class="price__container"><div class="price__regular"><span class="visually-hidden visually-hidden--inline">Regular price</span>
        <span class="price-item price-item--regular">
         ${helpers.currencify(product.price / 100)}
        </span></div>
    <div class="price__sale">
        <span class="visually-hidden visually-hidden--inline">Regular price</span>
        <span>
          <s class="price-item price-item--regular">
            
              ${product.compare_at_price}
            
          </s>
        </span><span class="visually-hidden visually-hidden--inline">Sale price</span>
      <span class="price-item price-item--sale price-item--last">
        ${product.price}
      </span>
    </div>
    <small class="unit-price caption hidden">
      <span class="visually-hidden">Unit price</span>
      <span class="price-item price-item--last">
        <span></span>
        <span aria-hidden="true">/</span>
        <span class="visually-hidden">&nbsp;per&nbsp;</span>
        <span>
        </span>
      </span>
    </small>
  </div><span class="badge price__badge-sale color-accent-2">
      Sale
    </span>

    <span class="badge price__badge-sold-out color-background-2">
      Sold out
    </span></div>
</div><div class="product__tax caption rte">Tax included.
<a href="/en/policies/shipping-policy">Shipping</a> calculated at checkout.
</div><div><form method="post" action="/en/cart/add" id="product_form_8785746657604" accept-charset="UTF-8" class="shopify-product-form" enctype="multipart/form-data"><input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓"><input type="hidden" name="id" value="47634727665988">
                      
<input type="hidden" name="product-id" value="${product.id}"><input type="hidden" name="section-id" value="template--20993645576516__81813185-3340-401f-bade-279d711e3872"></form></div>
${product.variants.length > 1 ? `<random-featured-variant-radios 
  id="variant-radios-template--20993645576516__81813185-3340-401f-bade-279d711e3872" 
  class="no-js-hidden" data-section="template--20993645576516__81813185-3340-401f-bade-279d711e3872" 
  data-url="${'/products/' + product.handle}" data-update-url="false">
  ${product.options.length ? (
    `<fieldset class="js product-form__input">
    <legend class="form__label">${product.options[0]}</legend>
    ${product.options_with_values[0]?.values?.map((val, index) => (
      `<input type="radio" id="template--20993645576516__81813185-3340-401f-bade-279d711e3872-1-${index}" name="${product.options_with_values[0].name}" value='${val}' form="product-form-template--20993645576516__81813185-3340-401f-bade-279d711e3872" checked="${index === 0}">
      <label for="template--20993645576516__81813185-3340-401f-bade-279d711e3872-1-${index}">
        ${val}<span class="visually-hidden">Variant sold out or unavailable</span>
      </label>`
    )).join('')}
  </fieldset>`
  ) : ''}
  
  <script type="application/json">
      ${JSON.stringify(product.variants)}
       </script>
  </random-featured-variant-radios>` : '' }
    
  <noscript class="product-form__noscript-wrapper-template--20993645576516__81813185-3340-401f-bade-279d711e3872">
  <div class="product-form__input">
    <label class="form__label" for="Variants-template--20993645576516__81813185-3340-401f-bade-279d711e3872">Product variants</label>
    <div class="select">
      <select
        name="id"
        id="Variants-template--20993645576516__81813185-3340-401f-bade-279d711e3872"
        class="select__select"
        form="product-form-template--20993645576516__81813185-3340-401f-bade-279d711e3872"
      >${product.variants.map(variant => (
        `<option selected="selected" value="${variant.id}">${variant.title} - ${variant.price}</option>`
      )).join('')}
        </select>
      <svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
</svg>

    </div>
  </div>
</noscript>

<div id="Quantity-Form-template--20993645576516__81813185-3340-401f-bade-279d711e3872" class="product-form__input product-form__quantity">
                  
                  

                  <label class="quantity__label form__label" for="Quantity-template--20993645576516__81813185-3340-401f-bade-279d711e3872">
                    Quantity
                    <span class="quantity__rules-cart no-js-hidden hidden">

<link href="//elcielicious.com/cdn/shop/t/5/assets/component-loading-spinner.css?v=116724955567955766481708866502" rel="stylesheet" type="text/css" media="all">

<div class="loading__spinner hidden">
  <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
    <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
  </svg>
</div>
<span>(<span class="quantity-cart">0</span> in cart)</span>
                    </span>
                  </label>
                  <div class="price-per-item__container">
                    <quantity-input class="quantity">
                      <button class="quantity__button no-js-hidden disabled" name="minus" type="button">
                        <span class="visually-hidden">Decrease quantity for Funky Fat Choc Dark</span>
                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-minus" fill="none" viewBox="0 0 10 2">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor">
</path></svg>

                      </button>
                      <input class="quantity__input" type="number" name="quantity" id="Quantity-template--20993645576516__81813185-3340-401f-bade-279d711e3872" data-cart-quantity="0" data-min="1" min="1" step="1" value="1" form="product-form-template--20993645576516__81813185-3340-401f-bade-279d711e3872" max="null">
                      <button class="quantity__button no-js-hidden" name="plus" type="button">
                        <span class="visually-hidden">Increase quantity for Funky Fat Choc Dark</span>
                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-plus" fill="none" viewBox="0 0 10 10">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor">
</path></svg>

                      </button>
                    </quantity-input></div>
                  <div class="quantity__rules caption no-js-hidden" id="Quantity-Rules-template--20993645576516__81813185-3340-401f-bade-279d711e3872"></div></div>
<div><product-form class="product-form" data-hide-errors="false" data-section-id="template--20993645576516__81813185-3340-401f-bade-279d711e3872">
      <div class="product-form__error-message-wrapper" role="alert" hidden="">
        <svg aria-hidden="true" focusable="false" class="icon icon-error" viewBox="0 0 13 13">
          <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"></circle>
          <circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"></circle>
          <path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"></path>
          <path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7">
        </path></svg>
        <span class="product-form__error-message"></span>
      </div><form method="post" action="/en/cart/add" id="product-form-template--20993645576516__81813185-3340-401f-bade-279d711e3872" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form"><input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓"><input type="hidden" name="id" value="${product.variants[0].id}" class="product-variant-id"><div class="product-form__buttons"><button id="ProductSubmitButton-template--20993645576516__81813185-3340-401f-bade-279d711e3872" type="submit" name="add" class="product-form__submit button button--full-width button--primary" aria-haspopup="dialog">
            <span>Add to cart
</span>

<link href="//elcielicious.com/cdn/shop/t/5/assets/component-loading-spinner.css?v=116724955567955766481708866502" rel="stylesheet" type="text/css" media="all">

<div class="loading__spinner hidden">
  <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
    <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
  </svg>
</div>
</button></div><input type="hidden" name="product-id" value="8785746657604"><input type="hidden" name="section-id" value="template--20993645576516__81813185-3340-401f-bade-279d711e3872"></form></product-form></div>
<a href="/en/products/funky-fat-choc-dark" class="link product__view-details animate-arrow">
            View full details
            <svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor">
</path></svg>

          </a>
        </product-info>
      </div>`;

    this.featuredProductDiv.innerHTML = html;    
  }
}

featuredProductFetchApp.init();


const productCardActivityTrackingScripts = {
  init() {
    const productCards = this.productCards = document.querySelectorAll('.card--product');
    if (!productCards.length) return;
    this.hoverData = {};
    this.minimumHoverDuration = 2000; // 2 second threshold
    this.main = document.querySelector('#MainContent');
    this.setupEventListeners();
  },

  setupEventListeners() {
    this.productCards.forEach(card => card.addEventListener('mouseenter', this.handleMouseEnter.bind(this)));
    this.productCards.forEach(card => card.addEventListener('mouseleave', this.handleMouseLeave.bind(this)));
  },

  handleMouseEnter(e) {
    const card = e.currentTarget;
    const { productId } = card.dataset;
    this.hoverData[productId] = {
      start: Date.now(),
      duration: this.hoverData[productId]?.duration ?? 0
    }
    console.log({ start: Date.now(), })
  },

  handleMouseLeave(e) {
    const card = e.currentTarget;
    const { productId } = card.dataset;
    const hoverDuration = Date.now() - (this.hoverData[productId].start || Date.now());
    this.hoverData[productId].end = Date.now();
    this.hoverData[productId].duration += hoverDuration;
    console.log({ hoverDuration, productId })
    if (hoverDuration >= this.minimumHoverDuration) {
      debugger;
      const product = JSON.parse(card.querySelector('[type="application/product-json"]')?.textContent);
      if (!product?.available) return;
      const productOptionsWithValues = JSON.parse(card.querySelector('[type="application/product-options-json"]')?.textContent);
      if (!(product && productOptionsWithValues)) return;
      product.options_with_values = productOptionsWithValues;
      recommendedProductsApp.add(product);
      this.minimumHoverDuration = this.hoverData[productId].duration;
    }
  }
}

productCardActivityTrackingScripts.init();
